import { render, staticRenderFns } from "./Ltv.vue?vue&type=template&id=0a99787b&scoped=true"
import script from "./Ltv.vue?vue&type=script&lang=js"
export * from "./Ltv.vue?vue&type=script&lang=js"
import style0 from "./Ltv.vue?vue&type=style&index=0&id=0a99787b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99787b",
  null
  
)

export default component.exports